var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playVideo-layout"},[_c('div',{staticClass:"videoBox"},[_c('video',{staticClass:"video",attrs:{"controls":"controls","preload":"auto","webkit-playsinline":"","playsinline":"","x-webkit-airplay":"allow","x5-playsinline":"true","poster":_vm.form.cover_path,"src":_vm.form.live_link}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }